import { EBundlesViewModel } from "@appcharge/shared-ui";
import { EBadgeType } from "common/contracts";
import { ESpecialOfferInternalViewModel } from "constants/enums";

export const MAP_OFFER_MODEL_TO_HAS_ONE_MAIN: Partial<
    Record<ESpecialOfferInternalViewModel, boolean>
> = {
    [ESpecialOfferInternalViewModel.HUGE]: true,
    [ESpecialOfferInternalViewModel.BABA]: true,
    [ESpecialOfferInternalViewModel.PIPA]: true,
    [ESpecialOfferInternalViewModel.BIG_FISH_CASINO]: true,
    [ESpecialOfferInternalViewModel.JACKPOT_SLOTS]: true
};

export const MAP_VIEW_MODEL_TO_BADGE_TYPE: Record<EBundlesViewModel, EBadgeType> = {
    [EBundlesViewModel.LINEAR]: EBadgeType.EMBLEM,
    [EBundlesViewModel.THREE_IN_ONE]: EBadgeType.RIBBON,
    [EBundlesViewModel.SIX_IN_ONE]: EBadgeType.EMBLEM,
    [EBundlesViewModel.TWO_IN_ONE]: EBadgeType.RIBBON,
    [EBundlesViewModel.TWO_IN_ONE_DYNAMIC]: EBadgeType.RIBBON
};

